module.exports = __webpack_public_path__ + "img/photo.60e9614f.png";